import React, { FC } from 'react';
import { Typography } from '@design-system/typography';

interface BlockWithTextAndLinkProps {
  title: string;
  description: string;
  cta: string;
}

const BlockWithTextAndLink: FC<BlockWithTextAndLinkProps> = ({ title, description, cta }) => (
  <div className="reviews-section">
    <div className="reviews-section__content">
      <Typography
        content={title}
        variant="headline"
        size="xxl"
        className="reviews-section__title"
      />
      <Typography
        content={description}
        variant="body"
        size="m"
        className="reviews-section__description"
      />
      <a href={cta} className="reviews-section__link">
        READ NOW
      </a>
    </div>
  </div>
);

export default BlockWithTextAndLink;
